import { DataCallWrapper } from 'src/api/types';
import { uniqueId } from 'lodash';

export const transformToTickets = (detail?: DataCallWrapper) => {
    const ticketRelateFieldList = detail?.ticketRelateFieldList || [];

    const ticketRelateFieldValueMapList = detail?.ticketRelateFieldValueMapList || [];

    const tickets = ticketRelateFieldValueMapList.map((t) => {
        return {
            id: uniqueId('ticket_'),
            contents: Object.entries(t).map(([key, value]) => {
                const field = ticketRelateFieldList.find((field) => field.id === key);
                return {
                    key: field?.label,
                    value,
                };
            }),
        };
    });

    return tickets;
};
